var _line, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline01Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timeline_01_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.937,
    height: 535.512,
    viewBox: "0 0 284.937 535.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_35",
    "data-name": "L\\xEDnea 35",
    x1: 1.254,
    y2: 308.672,
    transform: "translate(141.5 226.828)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1191",
    "data-name": "Grupo 1191",
    transform: "translate(-102.246 -330.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1189",
    "data-name": "Grupo 1189"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_187",
    "data-name": "Elipse 187",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "translate(132.889 553.319) rotate(-80.679)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_188",
    "data-name": "Elipse 188",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(129.932 473.026) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_01.",
    "data-name": 1,
    transform: "translate(164.396 411.151)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "01."))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1190",
    "data-name": "Grupo 1190"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_76",
    "data-name": "Rect\\xE1ngulo 76",
    width: 284.937,
    height: 41.829,
    transform: "translate(102.246 587.392)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Febrero_2018",
    "data-name": "Febrero 2018",
    transform: "translate(171.87 614.746)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Febrero 2018"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1192",
    "data-name": "Grupo 1192",
    transform: "translate(-102.246 -330.172)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Proyecto_Dades_X_Dones_Creaci\\xF3n_de_redes",
    "data-name": "Proyecto Dades X Dones,  Creaci\\xF3n de redes",
    transform: "translate(161.285 424.961)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "Proyecto Dades "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53.117
  }, "X Dones, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 83.233
  }, "Creaci\xF3n de "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 113.35
  }, "redes")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1194",
    "data-name": "Grupo 1194",
    transform: "translate(-102.246 -330.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1193",
    "data-name": "Grupo 1193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_829",
    "data-name": "Trazado 829",
    d: "M254.034,359.3a12.041,12.041,0,1,0,12.041,12.041A12.055,12.055,0,0,0,254.034,359.3Zm0,19.266a7.225,7.225,0,1,1,7.225-7.225A7.233,7.233,0,0,1,254.034,378.568Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_830",
    "data-name": "Trazado 830",
    d: "M254.034,374.749l-3.4-3.4,3.4-3.406,3.406,3.406Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_831",
    "data-name": "Trazado 831",
    d: "M275.563,386.9a69.557,69.557,0,0,0-.676-14.455,75.439,75.439,0,0,0-14.719-34.1l-6.134-8.179-6.134,8.179a75.461,75.461,0,0,0-14.719,34.1,69.629,69.629,0,0,0-.675,14.455,23.536,23.536,0,0,0-9.779,19.1v6.457l5-3.664a21.507,21.507,0,0,1,8.293-3.273c.911,2.841,1.586,4.464,2.5,6.944,1.59-1.063,5.407-5.777,13.105-6.7v6.68h4.816v-6.68c7.721.927,11.532,5.65,13.105,6.7.92-2.495,1.589-4.1,2.5-6.944a21.5,21.5,0,0,1,8.292,3.273l5,3.664V406A23.545,23.545,0,0,0,275.563,386.9Zm-47.815,16.319a18.563,18.563,0,0,1,5.326-10.517,74.689,74.689,0,0,0,1.607,8.162A26.4,26.4,0,0,0,227.748,403.221Zm39.533,1.382a24.921,24.921,0,0,0-10.839-3.683V388.361h-4.816V400.92a24.917,24.917,0,0,0-10.839,3.683c-7.185-21.9-3.341-44.287,10.966-63.362l2.281-3.042,2.281,3.042C270.622,360.316,274.466,382.7,267.281,404.6Zm6.106-3.737a74.933,74.933,0,0,0,1.608-8.162,18.569,18.569,0,0,1,5.326,10.517A26.407,26.407,0,0,0,273.387,400.866Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_832",
    "data-name": "Trazado 832",
    d: "M212.934,349.669h14.61v4.816h-14.61Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_833",
    "data-name": "Trazado 833",
    d: "M280.525,349.669h14.609v4.816H280.525Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_834",
    "data-name": "Trazado 834",
    d: "M217.948,332.593l13.1,6.106-2.036,4.366-13.1-6.107Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_835",
    "data-name": "Trazado 835",
    d: "M290.12,371.564l-13.1-6.107,2.036-4.365,13.1,6.106Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_836",
    "data-name": "Trazado 836",
    d: "M215.912,367.2l13.1-6.105,2.036,4.364-13.1,6.107Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_837",
    "data-name": "Trazado 837",
    d: "M290.121,332.592l2.035,4.365-13.1,6.106-2.035-4.364Z",
    fill: "#1f2121"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline01Icuida);
export default __webpack_public_path__ + "static/media/timeline_01_icuida.87a70e56d75f4e7efa80221d9cfd0e60.svg";
export { ForwardRef as ReactComponent };